// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__xsLl1","col":"Table_col__2teEI","fulfillmentStatus":"Table_fulfillmentStatus__3451T","emailCol":"Table_emailCol__1QHnI"};